<script setup lang="ts">

const props = defineProps({
    label: String,
    tabId: String,
    active: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    }
});
</script>

<template>
    <li class="nav-item" role="presentation">
        <button :class="{'nav-link': true, 'active': props.active}" :id="props.tabId + '-tab'" data-bs-toggle="tab" :data-bs-target="'#' + props.tabId + '-tab-pane'" type="button" role="tab" :aria-controls="props.tabId + '-tab-pane'" aria-selected="true" :disabled="props.disabled">
            {{props.label}}
        </button>
    </li>
</template>

<style scoped>
button:disabled {
    cursor: not-allowed;
}
</style>
